import { Button, squareBlockCSS, styledOmitCustomProps } from '@braskai/ui-kit';

import { css, styled } from '@mui/material';

type SSidebarButtonProps = {
  $locked?: boolean;
};

export const SSidebarButton = styled(
  Button,
  styledOmitCustomProps,
)<SSidebarButtonProps>(
  ({ theme, $locked }) => css`
    ${squareBlockCSS(32)};
    border-radius: 6px;
    border: 1px solid transparent;
    padding: 7px;

    .MuiButton-icon svg {
      width: 16px;
      height: 16px;
      color: ${theme.palette.grey[700]};
    }

    &:hover,
    &:focus {
      background-color: ${theme.palette.grey[50]};

      .MuiButton-icon svg {
        color: ${theme.palette.grey[900]};
      }
    }

    ${$locked &&
    css`
      background-color: ${theme.palette.grey[50]};
      border-color: ${theme.palette.grey[100]};

      .MuiButton-icon svg {
        color: ${theme.palette.grey[900]};
      }
    `}
  `,
);
